import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
// import { Chart, registerables } from "chart.js";
// Crypto Treenvest Context Provider
import { MainControllerProvider } from "context";
import { MoralisProvider } from "react-moralis";

const inDevelopment = process.env.REACT_APP_NODE_ENV === "development";

export const SUPPORTED_CHAIN =
  (inDevelopment ? process.env.REACT_APP_TESTNET_CHAIN_ID : process.env.REACT_APP_CHAIN_ID) || "";

const APP_ID =
  (inDevelopment
    ? process.env.REACT_APP_TESTNET_MORALIS_APPLICATION_ID
    : process.env.REACT_APP_MORALIS_APPLICATION_ID) || "";

const SERVER_URL =
  (inDevelopment
    ? process.env.REACT_APP_TESTNET_MORALIS_SERVER_URL
    : process.env.REACT_APP_MORALIS_SERVER_URL) || "";

ReactDOM.render(
  <BrowserRouter>
    <MoralisProvider appId={APP_ID} serverUrl={SERVER_URL}>
      <MainControllerProvider>
        <App />
      </MainControllerProvider>
    </MoralisProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
